import { ContentOnexOne } from "./styles";
import ContentImage from "@/shared/ContentImage";
import ContentTitle from "@/shared/ContentTitle";
import { NormalArticle } from "@/widgets/Nota/Templates/stylesModulesGenericNormal.js";
import { LinkAbsolute } from "@/shared/LinkAbsolute";
import VideoLoop from "@/shared/VideoLoop";
import { clickContent } from "@/shared/Analitics/GoogleAnalytics4";
import useNewsDataModules from "@/hooks/useNewsDataModules";
import { getHourMinutes, getMonthDayYear } from "helpers";
import Streaming from "@/shared/Streaming";

const NewsAniversarySmall = (props) => {
  let streaming = Object.keys(props)?.filter((key) => /^streaming_/.test(key));
  if (streaming?.length > 0) {
    streaming = {
      link: props?.streaming_link,
      mute: props?.streaming_mute,
      autoplay: props?.streaming_autoplay,
    };
  } else {
    streaming = null;
  }

  const clippings = {
    desktop: ["rectangle_sm", "16_9_medianas", "2_1_S2"],
    mobile: ["rectangle_lg", "rectangle_sm", "16_9_medianas", "2_1_S2"],
  };

  if (props?.selectedClippingId) {
    clippings.desktop = [props.selectedClippingId, ...clippings.desktop];
    clippings.mobile = [props.selectedClippingId, ...clippings.mobile];
  }

  const {
    _id,
    asPath,
    author = [],
    authorSignature,
    children,
    containerName,
    cutTitle = false,
    iconMultimedia,
    image,
    imagePreview,
    imageWeb,
    isPreview,
    mams,
    payWallExclusive,
    publishedDate,
    section = [],
    showDate = false,
    subtitle,
    summary,
    title,
    url,
    urlTarget,
    videosOpenLoop,
    videoLoop,
    videoLoopFlavors = []
  } = useNewsDataModules(props, clippings);
  let date = true;
  if (publishedDate) {
    const publicationDate = new Date(publishedDate);
    const currentDate = new Date();
    if (getMonthDayYear(publicationDate) != getMonthDayYear(currentDate)) {
      date = getMonthDayYear(publishedDate);
    } else {
      date = getHourMinutes(publishedDate);
    }
  }
  const DOMAIN_URL = process.env.NEXT_PUBLIC_DOMAIN_URL || "https://www.clarin.com";

  let urlNote = url.replace(DOMAIN_URL+"/clarin80", "https://www.clarin80.com");

  return (
    <NormalArticle
      className={`${
        !streaming ? "normal-article-nota" : "normal-article-streaming-onexone"
      }`}
    >
      <ContentOnexOne
        className="NewsAniversarySmall"
        mamsEnabled={mams?.enabled}
      >
        {videosOpenLoop?.enabled ? (
          <VideoLoop videoLoop={videoLoop} width="640" videoLoopFlavors={videoLoopFlavors} />
        ) : !streaming ? (
          <picture>
            {isPreview ? (
              imagePreview && (
                <ContentImage
                  iconMultimedia={iconMultimedia}
                  data={imagePreview}
                  alt={title}
                />
              )
            ) : (
              <ContentImage
                iconMultimedia={iconMultimedia}
                data={imageWeb}
                alt={title}
                image={image}
              />
            )}
          </picture>
        ) : (
          <Streaming {...streaming} />
        )}

        <div className="aniversary-small">
          <p className="date">{props?.fecha && props.fecha}</p>
          {children}
          <ContentTitle
            _id={_id}
            type="NewsAniversarySmall"
            section={section}
            author={author}
            authorSignature={authorSignature}
            title={title}
            payWallExclusive={payWallExclusive}
            date={date}
            dateHours={true}
            cutTitle={cutTitle}
            showDate={showDate}
            contentType={props.contentType}
            summary={summary}
          />

          <div className="host-info">
            {props.nombrePresentador && (
              <p className="host-info-name">POR {props.nombrePresentador}</p>
            )}

            {props?.descripcionPresentador && (
              <p className="host-info-description">
                {props?.descripcionPresentador}
              </p>
            )}
          </div>
        </div>
        <LinkAbsolute
          href={urlNote}
          target="_self"
          aria-label={title}
          onClick={() =>
            clickContent(
              { contentType: title, contentCategory:"clarin80", contentList: containerName },
              urlNote,
              asPath
            )
          }
        />
      </ContentOnexOne>
    </NormalArticle>
  );
};

export default NewsAniversarySmall;
